import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { TgUserData } from 'src/app/interfaces/modules/technology/tg-user-data';
import { JsAuthService } from 'src/app/services/apis/java/spring/js-auth/js-auth.service';
import { JsCheckService } from 'src/app/services/apis/java/spring/js-check/js-check.service';
import { AuthService } from 'src/app/services/functions/auth/auth.service';
import { BaseurlService } from 'src/app/services/functions/baseurl/baseurl.service';
import { ConsoleService } from 'src/app/services/functions/console/console.service';
import { DomainService } from 'src/app/services/functions/domain/domain.service';
import { ElementService } from 'src/app/services/functions/element/element.service';
import { ModalService } from 'src/app/services/functions/modal/modal.service';
import { StorageService } from 'src/app/services/functions/storage/storage.service';
import { SweetService } from 'src/app/services/functions/sweet/sweet.service';
import { Environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
declare let bootstrap: any;

@Component({
  selector: 'app-ex-login',
  templateUrl: './ex-login.component.html',
  styleUrls: ['./ex-login.component.css']
})
export class ExLoginComponent implements OnInit {
  env: any = Environment;
  debug: string = this.env.app.debug;
  title: string = this.env.app.title;
  strgAuth: string = this.env.strg.auth;

  domainMajor: string = '';
  urlFront: string = '';

  loading: boolean = false;
  formSubmit: boolean = false;

  loginForm: FormGroup;
  tgUserData: TgUserData[] = [];

  constructor (
    public fb: FormBuilder,
    public router: Router,

    public jsAuth: JsAuthService,
    public jsCheck: JsCheckService,

    public srvAuth: AuthService,
    public srvBaseUrl: BaseurlService,
    public srvConsole: ConsoleService,
    public srvDomain: DomainService,
    public srvElement: ElementService,
    public srvModal: ModalService,
    public srvStorage: StorageService,
    public srvSweet: SweetService,
  ) {
    this.loginForm = this.formLogin();
  }

  ngOnInit(): void {
    this.getDomain();
    this.getUrlHref();
  }

  getDomain() {
    let dmMajor = this.srvDomain.getDomainInfo();
    this.domainMajor = dmMajor;
  }

  getUrlHref() {
    let urlDomain = this.domainMajor;
    let urlBase = this.srvBaseUrl.getBaseUrl();
    if (urlBase === '/') { urlBase = ''; }
    this.urlFront = urlDomain + urlBase;
    console.log(`urlFront: ${this.urlFront}`);
  }

  formLogin(): FormGroup {
    return this.fb.group({
      cdLogin: ['', Validators.required],
      cdPassword: ['', Validators.required],
    });
  }

  loadState(response: boolean) {
    // Ejecutar el spinner segun la respueta
    this.loading = this.srvModal.spinner(
      response
    );
  }

  async logionAction() {
    if (!this.loginForm.valid) {
      this.formSubmit = true;
      return;
    }
    this.loadState(true);

    try {
      // Registrar el tiempo inicial
      const startTime = performance.now();
      // Enviar la solicitud y esperar la respuesta
      const available = await this.jsCheck.verify();
      // Registrar el tiempo final
      const endTime = performance.now();
      // Calcular el tiempo total de la solicitud
      const elapsedTime = endTime - startTime;
      // Validar disponibilidad en el servicio
      this.verifyBackend(available, elapsedTime);
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => { this.loadState(false); }, 250);
    }

  }

  verifyBackend(available: any, elapsedTime: any) {
    // Obtener el codigo de la respuesta solicitada
    let resCode = available?.response?.code ?? 0;
    // Obtener el estado de la respuesta solicitada
    let resState = available?.response?.status ?? 0;
    // Verificar su definicion de respuesta
    if (typeof available !== 'undefined') {
      // Ejecutar operaciones adicionales
      setTimeout(async () => {
        // Cerrar ventana segun el estado de la peticion
        if (resState === 'success') { this.srvSweet.close(); }
        // Ejecutar el proceso segun el codigo de la peticion
        if (resCode === 200) { this.loginRequest(); }
      }, elapsedTime + 250);
    }
  }

  loginRequest() {
    // Obtener las propiedades segun el formulario
    const { cdLogin, cdPassword } = this.loginForm.value;
    // Crear un objeto de tipo con los datos del formulario
    const payload: TgUserData = {
      cdLogin: cdLogin,
      cdPassword: cdPassword,
    };
    // Ejecutar el servicio enviando los datos
    this.jsAuth.login(payload).subscribe({
      next: (response: any) => {
        this.loginNext(response);
      },
      error: (response: any) => {
        this.loginError(response);
      },
      complete: () => {
        console.log('request completed');
      },
    });
  }

  async loginNext(response: any) {
    console.log(response);
    this.loadState(false);
    if (response.status === 200) {
      let info = {
        response: {
          code: response.status,
          message: 'Acceso Autorizado',
          status: 'success',
        },
      };
      let final = await this.srvSweet.response(info);
      if (final?.confirmed) { this.loginAuth(response); }
    }
  }

  async loginError(response: any) {
    console.log(response);
    this.loadState(false);
    if (response.status === 403) {
      let info = {
        response: {
          code: response.status,
          message: 'Credenciales Incorrectas',
          status: 'error',
        },
      };
      await this.srvSweet.response(info);
    }
  }

  loginAuth(response: any) {
    let respBody = response.body;
    this.srvConsole.print('json', respBody);

    let dataStrg = this.strgGet();
    if (dataStrg) { this.strgRemove(); }
    if (dataStrg) { this.strgSet(response.body); }
    if (!dataStrg) { this.strgSet(response.body); }

    let verifyStrg = this.strgGet();
    if (verifyStrg) {
      this.router.navigate(
        ['/technology/user/ip']
      );
    }
  }

  // Obtener token de la autenticación
  strgGet() {
    return this.srvStorage.mode(
      'local', 'get', this.strgAuth
    );
  }

  // Asignar token de la autenticación
  strgSet(response: any) {
    this.srvStorage.mode(
      'local',
      'json',
      this.strgAuth,
      response
    );
  }

  // Remover token de la autenticación
  strgRemove() {
    this.srvStorage.mode(
      'local',
      'remove',
      this.strgAuth
    );
  }
}
